<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChat_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12 1H4a3 3 0 0 0-3 3v10.341c0 .59.754.836 1.102.36l1.358-1.859A2.06 2.06 0 0 1 5.119 12H12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3m0 7.5H4v-1h8zm0-3H4v-1h8z"
    />
</svg>
